import { Button, Container, CssBaseline, makeStyles, TextField, Typography, IconButton, FormControl, InputLabel, Input, InputAdornment } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { oper as v_oper, basic, Values, SNACKBAR_TIME } from '../request/values';

import React, { Fragment, useState } from 'react';
import { COLORS } from '../shared/Theme';

import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';

import { Visibility, VisibilityOff, Check } from '@material-ui/icons';
import { SIcon } from '../shared/Icon';

const useStyles = makeStyles((theme) => ({
	nanumSquare_regular: {
		fontFamily: 'NanumR',
	},
	background: {
		position: 'absolute',
		top: 0,
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	back: {
		marginLeft: '-1vh',
	},
	container: {
		width: '82%',
		marginTop: '7vh',
		padding: 0,
	},
	paper: {
		// marginTop: theme.spacing(8),
		// width: '82%',
		marginTop: '5vh',
		margin: 'auto',
		display: 'flex',
		flexDirection: 'column',
	},
	title: {
		// width: '80%',
		alignItems: 'left',
	},
	form: {
		width: '100%',
		marginTop: theme.spacing(1),
	},
	submit: {
		height: 60,
		color: `${COLORS.WATER_BLUE}`,
		textColor: '#ffffff',
		margin: theme.spacing(3, 0, 2),
		borderRadius: '27px',
		boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
		border: 'solid 0.5px #cfd4d9',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		'&:hover': {
			backgroundColor: `${COLORS.WATER_BLUE}`,
		},
	},
}));

const SERVER = basic.server;

const OperPassword: React.FC<any> = (props) => {
	const classes = useStyles();
	let history = useHistory();

	const [email, setEmail] = useState<string>('');
	const [emailAuth, setEmailAuth] = useState<boolean>(false);

	const [password, setPassword] = useState<string>('');
	const [passwordRe, setPasswordRe] = useState<string>('');
	const [check, setCheck] = useState<boolean>(false);
	const [showPassword, setShowPassword] = useState<boolean>(false);
	const [name, setName] = useState<string>('');

	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const buttonText = ['ID 확인하기', 'ID 확인 완료!'];

	console.log('in oper join');

	const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value, id } = e.target;

		if (id === 'email') {
			setEmail(value);
			setEmailAuth((prevState) => false);
		} else if (id == 'password') {
			setPassword(value);
			if (passwordRe == value) setCheck((prevState) => true);
			else setCheck((prevState) => false);
		} else if (id == 'passwordRe') {
			setPasswordRe(value);
			if (password == value) setCheck((prevState) => true);
			else setCheck((prevState) => false);
		}
	};

	const handleClickShowPassword = () => {
		setShowPassword((prevState) => !prevState);
	};

	const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};

	const getEmailAuth = () => {
		let url = new URL(SERVER + v_oper.oper + v_oper.auth_info);
		let params = { email: email ? email.toString().trim() : '' };
		url.search = new URLSearchParams(params).toString();

		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log(data);
				if (data.code == Values.SUCCESS_CODE) {
					console.log(data.name);
					setEmailAuth((prevState) => true);
					setName(data.name);
					enqueueSnackbar(data.name + '님의 아이디를 확인했습니다.', {
						variant: 'success',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else if (data.code == Values.FAIL_CODE) {
					enqueueSnackbar(ToastStr.EMAIL_EXCEPTION, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
					});
					setEmailAuth((prevState) => false);
				}
			});
	};

	const postPasswordChange = () => {
		axios({
			method: 'POST',
			withCredentials: true,
			data: {
				email: email,
				pwd: password,
			},
			url: SERVER + v_oper.oper + v_oper.update_pwd,
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log(data);
				if (data.code == Values.SUCCESS_CODE) {
					enqueueSnackbar(ToastStr.PW_CHANGE_SUCCESS, {
						variant: 'success',
						autoHideDuration: SNACKBAR_TIME,
					});
					window.location.href = 'https://educator.youstarter.co.kr';
				} else {
					if (data.code == Values.FAIL_CODE) {
						enqueueSnackbar(ToastStr.JOIN_FAIL_STR, {
							variant: 'warning',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else {
						enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
							variant: 'error',
							autoHideDuration: SNACKBAR_TIME,
						});
					}
				}
			});
	};

	const handleEmailButton = (e: any) => {
		if (!emailAuth) {
			if (email.length == 0) {
				enqueueSnackbar(ToastStr.EMAIL_ADDR_CHECK_STR, {
					variant: 'warning',
					autoHideDuration: SNACKBAR_TIME,
				});
			} else if (email.length > 32) {
				enqueueSnackbar(ToastStr.EMAIL_ADDR_CHECK_LEN, {
					variant: 'warning',
					autoHideDuration: SNACKBAR_TIME,
				});
			} else {
				getEmailAuth();
			}
		}
	};

	const handleAuthButton = (e: any) => {
		// e.preventDefault();
		console.log(e);
		if (!emailAuth) {
			enqueueSnackbar(ToastStr.EMAIL_AUTH_CHECK_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
		} else if (password.length < 6 || password.length > 20) {
			enqueueSnackbar(ToastStr.PWD_ET_CHECK_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
		} else if (!check) {
			enqueueSnackbar(ToastStr.PWD_CHECK_FALSE_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
			setPasswordRe('');
		} else {
			postPasswordChange();
		}
	};

	return (
		<div className={classes.background}>
			<Container component="main" className={classes.container}>
				<IconButton className={classes.back} onClick={() => history.goBack()}>
					<SIcon type="Back" />
				</IconButton>
				<div className={classes.paper}>
					<div className={classes.title}>
						<Typography variant="h4" style={{ color: `${COLORS.WATER_BLUE}` }}>
							{!emailAuth ? '변경할 아이디를 입력하세요' : '비밀번호 변경하기'}
						</Typography>
					</div>

					<div className={classes.form}>
						{/* Email */}
						<TextField
							variant="standard"
							margin="normal"
							required
							fullWidth
							id="email"
							label="ID를 입력하세요."
							name="email"
							autoComplete="email"
							autoFocus
							InputProps={{ style: { fontSize: '20px' } }}
							InputLabelProps={{ style: { fontSize: '18px' } }}
							value={email}
							onChange={valueChangeHandler}
							style={{ color: `${COLORS.charcoal_grey}` }}
						/>

						<Button type="submit" fullWidth variant="contained" className={classes.submit} onClick={handleEmailButton}>
							{emailAuth && (
								<Check
									style={{
										marginRight: '2vw',
										color: `${COLORS.WHITE}`,
									}}
								/>
							)}
							<Typography variant="h3">{emailAuth ? buttonText[1] : buttonText[0]}</Typography>
						</Button>

						{/* Password */}
						{!emailAuth ? (
							<div></div>
						) : (
							<div style={{ marginTop: '5vh' }}>
								<FormControl fullWidth>
									<InputLabel style={{ fontSize: '18px' }} htmlFor="filled-adornment-password">
										비밀번호를 입력하세요
									</InputLabel>
									<Input
										id="password"
										fullWidth
										type={showPassword ? 'text' : 'password'}
										value={password}
										onChange={valueChangeHandler}
										style={{ fontSize: '20px' }}
										endAdornment={
											<InputAdornment position="end">
												<IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
													{showPassword ? <Visibility /> : <VisibilityOff />}
												</IconButton>
											</InputAdornment>
										}
									/>
								</FormControl>

								<TextField
									variant="standard"
									margin="normal"
									fullWidth
									id="passwordRe"
									label="비밀번호를 다시 입력하세요"
									name="password"
									type="password"
									InputProps={{ style: { fontSize: '20px' } }}
									InputLabelProps={{
										style: { fontSize: '18px' },
									}}
									value={passwordRe}
									onChange={valueChangeHandler}
									style={{ color: `${COLORS.charcoal_grey}` }}
								/>

								<Button type="submit" fullWidth variant="contained" className={classes.submit} onClick={(e) => handleAuthButton(e)}>
									<Typography variant="h3">비밀번호 변경하기</Typography>
								</Button>
							</div>
						)}
					</div>
				</div>
			</Container>
		</div>
	);
};

export default OperPassword;
